import * as yup from "yup";

export const addEmployeeCommutingValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup.string().required("Month is required"),
  year: yup.string().required("Year is required"),
});
